/**
* reducers for the investment
*
* Created by Tom on 20/06/18
*/

import C from '../constants'

const initState = {
    loading: false,
    fetchSuccess: true,
    data: []
}

export const investmentState = (state = initState, action) => {

    switch(action.type) {

        // in case of `Loading` change
        case C.SET_INVESTMENT_LOADER:
            return {
                ...state,
                loading: action.payload
            }

        // in case of `Data` change
        case C.SET_INVESTMENT_DATA:
            return {
                ...state,
                data: action.payload
            }

        // in case of `iInvestmentSuccess` change
        case C.SET_INVESTMENT_FETCH_SUCCESS:
            return {
                ...state,
                fetchSuccess: action.payload
            }


        default: return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/investmentReducers.js